import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { TargetCircleFetchProps } from 'types/api'
import { IResponse } from 'utils/api'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchTargetCircle360 } from 'queries/loyalty/target-circle-360'
import { getGreenfieldDrillValues } from 'utils/greenfield'

export function useTargetCircle360({
    env,
    accessToken,
    dynamicSubPath,
    location,
    filters,
}: TargetCircleFetchProps): IResponse {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const normalizedLocation =
        location === 'Company Target' ? 'Company' : location
    const greenfieldFilters = getGreenfieldDrillValues(normalizedLocation)
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [
            QueryKeys.TARGET_CIRCLE_360,
            normalizedLocation,
            dynamicSubPath,
            filters?.time_dimension,
        ],
        () =>
            fetchTargetCircle360({
                env,
                accessToken,
                dynamicSubPath,
                filters: {
                    ...filters,
                    ...(greenfieldFilters && { ...greenfieldFilters }),
                },
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            retry: false,
        },
    )
    return { data, isLoading, isError, refetch, remove, error }
}
